module.exports = __webpack_public_path__ + "static/img/lg-ess-img-03-02@m.b359bf7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lg-ess/lg-ess-img-03-02@m.jpg
// module id = 3gOp
// module chunks = 0